export function when(F) {
    return b => x => b ? x : F.of(undefined);
}
export function unless(F) {
    return b => x => b ? F.of(undefined) : x;
}
export function pass(F) {
    return F.of(undefined);
}
